import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, PerformanceType } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class Video extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        src: {
          default: null,
        },
        streamId: {
          default: null,
        },
        file: {
          default: null,
        },
        caption: {
          default: null,
        },
        width: {
          default: null,
        },
        name: {
          default: null,
        },
        processing: {
          default: null,
        },
        allowForwarding: {
          default: true,
        },
        allowPlaybackSpeedControl: {
          default: false,
        },
        allowDownloading: {
          default: false,
        },
        captions: {
          default: null,
        },
        disabedCaptions: {
          default: null,
        },
        sections: {
          default: null,
        },
        downloadableUrl: {
          default: null,
        },
        thumbnail: {
          default: null,
        },
        allowBackgroundVideoPlayback: {
          default: false,
        },
        title: {
          default: null,
        },
        description: {
          default: null,
        },
        redirectLink: {
          default: null,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'video',
          getAttrs: (dom: any) => {
            return {
              src: dom.getAttribute('src'),
            };
          },
        },
      ],
      toDOM: (node) => {
        let url = node?.attrs?.url;
        return url
          ? ['div', { class: 'flex justify-center mt-16' }, ['video', { ...node.attrs }]]
          : ['div'];
      },
    };
  }

  plugins = plugins;

  get name(): string {
    return NODE_NAME;
  }

  get performanceType(): PerformanceType {
    return PerformanceType.BLOCK_BASED;
  }
}
